export const MAX_BULK_DELETE_AI_SYSTEMS = 50;
